import { inject } from '@angular/core';
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { SessionService, User, UserType } from '@kimbocare/core';
import { Observable } from 'rxjs';


export function guestGuard(): CanActivateFn {
  return (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree => {
    const authService: SessionService = inject(SessionService);
    const authState = authService.getAuthState();
    if (!authState?.token || authState?.user?.user_type === UserType.Guest) {
      return true;
    }
    return false;
  };
}
